import React, { useState } from 'react';
import Section from '../ui/Section';
import Heading from '../ui/Heading';
import { ChevronDown, ChevronUp } from 'lucide-react';

const LeadershipTeam = () => {
  const [expandedMember, setExpandedMember] = useState(null);

  const teamMembers = [
    {
      name: "Ramesh Ganapathi Hegde",
      role: "Managing Partner",
      bio: "Ramesh Ganapathi Hegde is a seasoned Director with a strong background in the construction and real estate industry. With extensive experience spanning several years, he brings a wealth of knowledge and expertise to Vasudharini Homes LLP. His leadership and strategic vision have been instrumental in driving the company's growth and success. Ramesh's dedication to innovation, affordability, and sustainable practices aligns perfectly with the company's mission to provide quality and affordable housing solutions to the middle-income group. His commitment to excellence and community development continues to shape Vasudharini Homes LLP's future endeavors.",
    },
    {
      name: "Revathi Ramesh Hegde",
      role: "Partner",
      bio: "Revathi Ramesh Hegde is a highly accomplished Director, known for her outstanding contributions to the construction and real estate industry. With a rich and diverse background, she has played a pivotal role in shaping the success of Vasudharini Homes LLP. Revathi's leadership is characterized by a strong commitment to innovation, sustainability, and affordability, perfectly aligning with the company's mission of providing quality, cost-effective housing solutions to the middle-income segment. Her dedication to community development and her relentless pursuit of excellence have been instrumental in driving the company forward, making Vasudharini Homes LLP a trusted name in the industry under her guidance.",
    },
  ];

  const toggleMember = (index) => {
    if (expandedMember === index) {
      setExpandedMember(null);
    } else {
      setExpandedMember(index);
    }
  };

  return (
    <Section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <Heading level={2} className="text-4xl font-bold text-gray-800 mb-4">
            Leadership Team
          </Heading>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Pioneering vision, transforming real estate landscapes
          </p>
        </div>

        <div className="space-y-6">
          {teamMembers.map((member, index) => (
            <div 
              key={index} 
              className={`transition-all duration-300 overflow-hidden ${
                expandedMember === index ? 'bg-gray-50' : 'bg-white'
              }`}
            >
              <button 
                onClick={() => toggleMember(index)}
                className="w-full p-6 flex flex-row items-center justify-between gap-4 text-left border-b focus:outline-none hover:bg-gray-50"
              >
                <div>
                  <h3 className="text-lg sm:text-xl font-medium text-gray-800">
                    {member.name}
                  </h3>
                  <div className="mt-2 inline-block bg-yellow-100 text-yellow-800 py-1 px-3 rounded-full text-sm font-medium">
                    {member.role}
                  </div>
                </div>
                
                <div className="flex-shrink-0">
                  {expandedMember === index ? (
                    <ChevronUp size={24} />
                  ) : (
                    <ChevronDown size={24} />
                  )}
                </div>
              </button>
              
              <div 
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  expandedMember === index ? 'max-h-96 py-6 opacity-100' : 'max-h-0 py-0 opacity-0'
                }`}
              >
                <p className="text-gray-600 leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Vision Statement */}
        <div className="mt-16 bg-gray-50 p-8 rounded-lg border-l-4 border-yellow-400">
          <Heading level={3} className="text-2xl font-medium mb-4">A Message from Our Founders</Heading>
          <p className="text-gray-700 italic leading-relaxed">
            "At Vasudharini, we believe that everyone deserves a home that doesn't just provide shelter, but 
            enhances their quality of life. Our commitment is to create spaces where families can thrive, 
            communities can grow, and investments can appreciate. We invite you to be a part of the Vasudharini family."
          </p>
        </div>
      </div>
    </Section>
  );
};

export default LeadershipTeam;